import React from "react";
import { BadgeCheck } from "lucide-react";

const SectionCard = ({ title, children, icon }) => (
  <div className="rounded-2xl border border-gray-100 bg-white">
    <div className="flex items-center justify-between border-b px-4 py-3">
      <div className="flex items-center gap-2">
        <div className="grid h-9 w-9 place-items-center rounded-xl bg-emerald-50 text-emerald-600">
          {icon || <BadgeCheck size={16} />}
        </div>
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      </div>
    </div>
    <div className="p-4">{children}</div>
  </div>
);

export default SectionCard;
